import { CollectionPresenterModel } from '@osos/shared/types';

// tslint:disable-next-line: no-namespace
export namespace CoreCollectionActions {
  export class FetchLookup {
    static readonly type = '[CoreLookup] Fetch Lookup';
    constructor(
      /**
       * lookup id
       */
      public lookupId: string,
    ) {}
  }

  /**
   * fetch lookups then you can read them from transitoryLookups selector.
   * here selectOnce or selectSnapshot must be used, don't use any other selection methods
   */
  export class TransitoryFetchLookups {
    static readonly type = '[CoreLookup] TransitoryFetch Lookups';
    constructor(
      public payload: {
        /**
         * normalized entity name or entity id
         */
        entityId?: string;
        skip?: number;
        limit?: number;
        searchTerm?: string;
        lookupIds?: string[];
        entityIds?: string[];
      },
    ) {}
  }

  export class ClearLookup {
    static readonly type = '[CoreLookup] Clear Lookup';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
      /**
       * lookup id
       */
      public lookupId: string,
    ) {}
  }

  export class UpdateLookup {
    static readonly type = '[CoreLookup] Update Lookup';
    constructor(
      /**
       * normalized entity name or entity id
       */
      public entityId: string,
      public payload: CollectionPresenterModel,
    ) {}
  }
}
